
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host,
.label-wrapper {
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host label,
.label-wrapper label {
  cursor: default;
  display: inline-flex;
  color: inherit;
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-family: var(--slh-default-font-family, "Open Sans");
  line-height: var(--slh-base-xxs-line-height, 24px);
}
:host label slot::slotted(*),
.label-wrapper label slot::slotted(*) {
  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
}
`;
